var intersectEllipse = require("./intersect-ellipse");

module.exports = intersectCircle;

function intersectCircle(node, rx, point) {
  return intersectEllipse(node, rx, rx, point);
}



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/lib/intersect/intersect-circle.js
// module id = 729
// module chunks = 0